<template>
  <div class="flex flex-wrap justify-between items-center">
    <Lynx-Title text="Renovação de Alvara"/>

    <Lynx-Button @click.native.prevent="openCreateModal()" class="mb-6 " text="Solicitar Renovação" />
    <Lynx-Button @click.native.prevent="relatorio()" class="mb-6" text="Relatorio" />

  <div class="w-full flex     justify-end mb-5 items-end">

    <div class="mr-1">
        <Lynx-Label label="Tipo" />
        <b-select
          placeholder="Selecione um Tipo"
          v-model="tipo"
        >
          <option
            v-for="(option, key) in tipoOptions"
            :value="option.value"
            :key="key"
            v-text="option.label"
          />
        </b-select>
      </div>
    <div class="">
        <Lynx-Label label="Status" />
        <b-select
          placeholder="Selecione um status"
          v-model="status"
        >
          <option
            v-for="(option, key) in statusOptions"
            :value="option.value"
            :key="key"
            v-text="option.label"
          />
        </b-select>
      </div>
      </div>
    <b-table
      class="w-full table table-responsive rounded-t-none"
      :columns="columns"

      :data="list_alvaraRenovacao"
      :loading="loading"
      default-sort="id"
      hoverable
      per-page="10"
      paginated
    >
      <template slot-scope="props">
        <b-table-column field="empresa_id"  >
          {{ props.row.empresa && props.row.empresa.id || '' }}
        </b-table-column>

        <b-table-column field="razao_social"  >
          {{ (props.row.empresa) ? props.row.empresa.razao_social || props.row.empresa.nome_empresa : '' }}
        </b-table-column>

   <b-table-column field="tipo" >
          {{ tipoOptions.find(item => item.value == props.row.tipo).label }}
        </b-table-column>
        <b-table-column field="estado">
  {{ props.row.endereco && props.row.endereco.uf ? props.row.endereco.uf : 'N/A' }}
</b-table-column>

<b-table-column field="cidade">
  {{ props.row.endereco && props.row.endereco.cidade ? props.row.endereco.cidade : 'N/A' }}
</b-table-column>


        <b-table-column field="status" >
          {{ props.row.status_label }}
        </b-table-column>
    
        <b-table-column class="flex justify-between" field="actions" label="" width="120">
          <!-- <b-tooltip v-if="props.row.status_id == 2 " label="Confirmar Pagamento" position="is-bottom" type="is-success">
            <button class="flex items-center justify-center" @click.prevent="confirmPayment(props.row.id)">
              <b-icon icon="currency-usd"></b-icon>
            </button>
          </b-tooltip> -->

          <b-tooltip v-if="props.row.status_id == 1 " label="Editar" position="is-bottom">
            <button class="flex items-center justify-center" @click.prevent="openEditModal(props.row)">
              <b-icon icon="circle-edit-outline"></b-icon>
            </button>
          </b-tooltip>

          <b-tooltip label="Excluir" position="is-bottom" type="is-danger">
            <button class="flex items-center justify-center" @click.prevent="deleteAlvaraRenovacao(props.row.id)">
              <b-icon icon="delete-forever"></b-icon>
            </button>
          </b-tooltip>
        </b-table-column>
      </template>

      <template slot="empty">
        <Not-Found-Data class="mt-8" text="Nenhuma renovação de renovação foi encontrada" />
      </template>
    </b-table>

    <b-modal :active.sync="alvaraRenovacaoCreateModalOpened">
      <AlvaraRenovacaoCreateModal @created="alteracaoCreated()" />
    </b-modal>

    <b-modal :active.sync="alvaraRenovacaoEditModalOpened" :on-cancel="fetchAlvaraRenovacao">
      <AlvaraRenovacaoEditModal :alvaraRenovacao="selectedAlvaraRenovacao" @edited="alteracaoEdited()" />
    </b-modal>
  </div>
</template>

<script>

import { AlvaraRenovacaoIndex, AlvaraRenovacaoDelete, AlvaraRenovacaoUpdate } from '@/services/requests/alvaraRenovacao'
import NotFoundData from '@/components/layouts/NotFoundData'
import AlvaraRenovacaoCreateModal from '@/views/empresas/renovacao/CreateModal'
import AlvaraRenovacaoEditModal from '@/views/empresas/renovacao/EditModal'

export default {
  name: 'AlvaraRenovacaoIndex',
  components: {  NotFoundData, AlvaraRenovacaoCreateModal, AlvaraRenovacaoEditModal },
  data() {
    return {
      alvaraRenovacaoCreateModalOpened: false,
      alvaraRenovacaoEditModalOpened: false,
      selectedAlvaraRenovacao: null,
      alvaraRenovacao: [],
      loading: false,
      columns: [
      {
          field: "empresa.id",
          label: "id",
          sortable: true,
          searchable: true,

        },
        {
          field: "empresa.razao_social",
          label: "Razão Social",
          sortable: true,
          searchable: true,
        },
        {
          field: "tipo",
          label: "Tipo",
          sortable: true,
          searchable: false,
        },
        {
          field: "endereco.uf",
          label: "Estado",
          sortable: true,
          searchable: true,

        },
        {
          field: "endereco.cidade",
          label: "Cidade",
          sortable: true,
          searchable: true,
        },
        {
          field: "status_label",
          label: "status",
          sortable: false,
          searchable: false,

        },
     
      ],
      
      statusOptions: [
      {
        label: "todos",
        value: "todos",

      },
      {
        label: "Em processo de renovação",
        value: "Em processo de renovação",
      },
      {
        label: "Aguardando pagamento",
        value: "Aguardando pagamento",
      },
      {
        label: "Finalizado",
        value: "Finalizado Renovação",
      },
   
    ],
    tipoOptions: [
      {
        label: "todos",
        value: "todos",

      },
      {
        label: "Alvará de funcionamento",
        value: 1,
      },
      {
        label: "Alvará  de Bombeiro",
        value: 2,
      },
      {
        label: "Alvará  de vigilãncia",
        value: 3,
      },
      {
        label: "Alvará  de meio ambiente",
        value: 4,
      },
   
    ],
    status:'todos',
    tipo:'todos',


    }
  },
  mounted() {
    this.fetchAlvaraRenovacao()
  },
  computed:{
    list_alvaraRenovacao(){
      // return this.alvaraRenovacao;
      let a,b 
    a =    this.alvaraRenovacao.filter(item=>{
if(this.status == 'todos')return true
     return  item.status_label  == this.status
    })

    b = a.filter(item=>{
if(this.tipo == 'todos')return true
     return  item.tipo  == this.tipo
    })
return b
    }
  },
  methods: {
   
    alteracaoCreated() {
      this.alvaraRenovacaoCreateModalOpened = false
      this.fetchAlvaraRenovacao()
    },
    alteracaoEdited() {
      this.alvaraRenovacaoEditModalOpened = false
      this.fetchAlvaraRenovacao()
    },
    openCreateModal() {
      this.alvaraRenovacaoCreateModalOpened = true
    },
    fetchAlvaraRenovacao() {
      this.loading = true
      AlvaraRenovacaoIndex()
        .then(res => {
          this.alvaraRenovacao = res.data.data
        })
        .finally(() => this.loading = false)
    },
    deleteAlvaraRenovacao(AlvaraRenovacaoId) {
      this.$buefy.dialog.confirm({
        title: 'Excluindo Solicitação de Renovação',
        message: 'Isso irá excluir essa renovação de renovação, deseja realmente continuar?',
        confirmText: 'Excluir',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.loading = true
          AlvaraRenovacaoDelete(AlvaraRenovacaoId)
            .then(() => {
              this.$snack.success('Solicitação de renovação excluída com sucesso!')
            })
            .finally(() => {
              this.loading = false
              this.fetchAlvaraRenovacao()
            })
        }
      })
    },
    confirmPayment(AlvaraRenovacaoId) {
      this.$buefy.dialog.confirm({
        title: 'Confirmação de Pagamento',
        message: 'Confirma o pagamento da renovação?',
        confirmText: 'Confirmar',
        type: 'is-success',
        hasIcon: true,
        onConfirm: () => {
          this.loading = true
          AlvaraRenovacaoUpdate(AlvaraRenovacaoId, [])
            .then(() => {
              this.$snack.success('Pagamento confirmado com sucesso!')
            })
            .finally(() => {
              this.loading = false
              this.fetchAlvaraRenovacao()
            })
        }
      })
    },
    openEditModal(alvaraRenovacao) {
      this.selectedAlvaraRenovacao = alvaraRenovacao
      this.alvaraRenovacaoEditModalOpened = true
    },
    relatorio() {
      window.open(
        `${process.env.VUE_APP_API_URL}/alvaraRenovacao/relatorio/?token=${this.$store.getters.getToken}`,
        "_blank"
      );
    },
  }
}
</script>
